import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { getAward, updateAward } from '../../../api/award.api';
import ErrorResponse from '../../../components/ErrorResponse';
import SimpleHeader from '../../../components/layout/SimpleHeader';
import Loader from '../../../components/Loader';
import AwardEditor from '../../../components/program/award/Editor';
import useAxios from '../../../hooks/useAxios';
import useNotification from '../../../hooks/useNotification';
import {
  IAwardModifyReq,
  IAwardReq,
  IGetAward,
} from '../../../models/award.model';

interface IMatch {
  awardCode: string;
}

const ProgramAwardEdit = () => {
  const { t } = useTranslation();
  const match = useRouteMatch<IMatch>();
  const awardCode = match.params.awardCode;
  const history = useHistory();
  const { successNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios<IGetAward>();
  const {
    data: submitRes,
    isLoading: submitIsLoading,
    error: submitError,
    execute: submitExecute,
  } = useAxios();

  useEffect(() => {
    if (awardCode) {
      execute(getAward(awardCode));
    }
  }, [awardCode]);

  useEffect(() => {
    if (submitRes && !submitIsLoading) {
      successNotification(t('common.message.save1'));
      history.push('/program/award');
    }
  }, [submitRes, submitIsLoading]);

  const submit = (data: IAwardReq | IAwardModifyReq) => {
    submitExecute(updateAward(awardCode, data as IAwardModifyReq));
  };

  return (
    <div className="content scrollbar">
      {isLoading || submitIsLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
      <ErrorResponse error={submitError} />
      <SimpleHeader
        parentMenu={t('program.award.title1')}
        currentMenu={t('program.award.title4')}
        iconFile="icon-program-big.svg"
      />
      <AwardEditor data={res?.data} submit={submit} />
    </div>
  );
};

export default ProgramAwardEdit;
